// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-3432d7df] {\n  margin-left: 250px;\n  margin-right: 250px;\n  max-width: calc(100vw - 300px);\n}\n.form-title[data-v-3432d7df] {\n  display: flex;\n}\n.profile-item[data-v-3432d7df] {\n  width: 50%;\n}\n.avatarEdit[data-v-3432d7df]:hover {\n  cursor: pointer;\n}\n.avatarEdit .mdi-pencil-circle[data-v-3432d7df] {\n  color: #1565C0;\n  opacity: 100%;\n  background: white;\n  border-radius: 50%;\n}", ""]);
// Exports
module.exports = exports;
